import { EntityContext, Message } from '@msdk/definitions'

import { ApiClient } from '../../api'
import { AsyncCache } from '../../react'
import { CancellationToken } from '../../state/signalr'
import { UrlContext } from '../../state/url-context'
import { ComponentModal, DialogInputModal, DialogModal, FormModal, ViewModal } from '../modals'
import { CustomLogicArgs } from './custom-logic-args'
import { CustomLogicEvent } from './custom-logic-event'
import { FieldChangedArgs } from './field-changed-args'

export type ActionId = 'MOVE_TO_BIN' | 'DELETE' | 'RESTORE'

export abstract class CustomLogicBase {
  protected readonly apiClient: ApiClient
  protected readonly formModal: FormModal
  protected readonly viewModal: ViewModal
  protected readonly componentModal: ComponentModal
  protected readonly dialogModal: DialogModal
  protected readonly dialogInputModal: DialogInputModal
  protected readonly translate: (idml: string, description: string) => string
  protected readonly asyncCache: AsyncCache
  protected readonly urlContext: UrlContext
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected readonly registerSignalrTopic: (topic: string, callback: (data: any) => void) => CancellationToken
  protected readonly navigate: (
    url: string,
    sitemap?: string,
    additionalCtx?: Record<string, string>,
    query?: URLSearchParams,
  ) => void
  protected readonly refetchEntity: (id?: string, parentId?: string) => Promise<void>
  protected readonly rebindEntity: (entityContext: EntityContext, pendingChanges: boolean) => void

  constructor(args: CustomLogicArgs) {
    this.apiClient = args.apiClient
    this.formModal = args.modals.formModal
    this.viewModal = args.modals.viewModal
    this.componentModal = args.modals.componentModal
    this.dialogModal = args.modals.dialogModal
    this.dialogInputModal = args.modals.dialogInputModal
    this.translate = args.translate
    this.asyncCache = args.asyncCache
    this.registerSignalrTopic = args.registerSignalrTopic
    this.urlContext = args.urlContext
    this.navigate = args.navigate
    this.refetchEntity = args.refetchEntity
    this.rebindEntity = args.rebindEntity
  }

  public postLoad(_entity: EntityContext, _e: CustomLogicEvent): Promise<void> {
    return Promise.resolve()
  }

  public onFieldChanged(_entity: EntityContext, _args: FieldChangedArgs, _e: CustomLogicEvent): Promise<void> {
    return Promise.resolve()
  }

  public validate(_entity: EntityContext, _e: CustomLogicEvent): Promise<void> {
    return Promise.resolve()
  }

  /**
   * called before triggering the save operation
   * @returns if true the mSDK will continue and save the entity, otherwise it will interrupt the operation
   */
  public preSave(_entity: EntityContext, _e: CustomLogicEvent): Promise<boolean> {
    return Promise.resolve(true)
  }

  public save(_entity: EntityContext, _e: CustomLogicEvent): Promise<boolean> {
    return Promise.resolve(true)
  }

  public postSave(_entity: EntityContext, _e: CustomLogicEvent): Promise<void> {
    return Promise.resolve()
  }

  public onSaveFailure(_messages: Message[], _e: CustomLogicEvent): Promise<void> {
    return Promise.resolve()
  }

  public onFormAction(_entity: EntityContext, _actionId: ActionId, _e: CustomLogicEvent): Promise<boolean> {
    return Promise.resolve(true)
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onDestroy(): void {}
}
